export default __webpack_public_path__ + "static/media/directory-member-female.3b8759e3.svg";